import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { RoleDetailsService } from '../../../core/services/role-details.service';
import { RoleService } from '../../../core/services/role.service';
import { EnvironmentLoaderService } from 'src/app/core/services/environment-loader.service';
import { environment } from 'src/environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

@Component({
  selector: 'app-select-popup',
  templateUrl: './role-select.component.html',
  styleUrls: ['./role-select.component.scss'],
  standalone: false,
})
export class RoleSelectComponent implements OnInit {
  // telemetry data to pass
  data1 = {
    // Required
    type: 'Role Select Component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '1', //Required.  Unique page id
  };
  reasons = [
    { value: 'DBAD', viewValue: 'DB Admin' },
    { value: 'DBAS', viewValue: 'DB Associate' },
    { value: 'SCAD', viewValue: 'Scheduler Admin' },
    { value: 'SCAS', viewValue: 'Scheduler Associate' },
    { value: 'OFDA', viewValue: 'Offer DB Associate' },
    { value: 'RECRUITER', viewValue: 'Recruiter' },
    { value: 'RM', viewValue: 'Recruitment Manager' },
    { value: 'CnB', viewValue: 'CnB' },
    { value: 'CnBAdmin', viewValue: 'CnB Admin' },
    { value: 'CnBExecutive', viewValue: 'CnB Executive' },
    { value: 'RH', viewValue: 'Recruitment Head' },
    { value: 'TPD', viewValue: 'TPD Head' },
    { value: 'OD', viewValue: 'OD' },
    { value: 'HiringManager', viewValue: 'Hiring Manager' },
  ];
  keyValueStore = {
    dbadmin: 'DBAD',
    dbassociate: 'DBAS',
    scheduleradmin: 'SCAD',
    scheduler: 'SCAS',
    offerdeo: 'OFDA',
    recruiter: 'RECRUITER',
    recruitmentmanager: 'RM',
    cnb: 'CnB',
    cnbadmin: 'CnBAdmin',
    cnbexecutive: 'CnBExecutive',
    recruitmenthead: 'RH',
    tpdhead: 'TPD',
    rec_lead: 'Rec_Lead',
    hroperations: 'HR Operations',
    operations: 'Operations',
    od: 'OD',
    hiringmanager: 'HiringManager',
    offer_admin: 'Offer_Admin',
    iaprec: 'IAPRec',
    bgcapprover1: 'BGC Approver 1',
    bgcapprover2: 'BGC Approver 2',
    docketanchor: 'Docket Anchor',
    recleadam: 'RecLeadAM',
  };
  role = '';
  roleDetails;
  activeButton;
  selectedRole = '';
  selectedContext = '';
  contextKey;
  contextKeyValue = {};
  showPhase(event) {
    this.activeButton = event;
  }

  constructor(
    public dialogRef: MatDialogRef<RoleSelectComponent>,
    private dataService: RoleDetailsService,
    private roleDetailService: RoleService,
    private envLoaderSerive: EnvironmentLoaderService,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _telemetryServices: TelemetryServices,
  ) {
    this.envLoaderSerive.getEnvData().then((envjson) => {
      environment.camsUrl = envjson['CamsUrl'];
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    // this.dataService.getRoles().subscribe(data => {
    //   this.roleDetails = data
    // })
    console.log(this.data);
    if (this.data.length == 1) {
      this.selectedRole = this.data[0].roleName;
      this.onSelect();
    }
    this.roleDetailService.getRoleDetails().subscribe((data) => {
      this.roleDetails = data;
      console.log('roleDetails:', this.roleDetails);
      this.roleDetailService.setRole(this.roleDetails);
    });
  }

  onRoleSelect() {
    this.data1.type = 'role select button click';
    this.data1.subtype = `Role:${this.selectedRole},Company Hiring Type Id:${this.selectedContext}`;
    this.data1.pageid = '1';
    this._telemetryServices.telemetryInteract(this.data1);
    if (this.selectedContext === '') {
      return 0;
    }
    this.roleDetails.forEach((data) => {
      this.dialogRef.close({
        roleDetails: data,
        role: this.role,
        selectedRole: this.selectedRole,
        selectedContext: this.selectedContext,
      });
    });
  }

  onSelect() {
    // this.role = val;
    console.log(this.selectedRole);
    console.log(environment.camsUrl);
    // if(this.selectedRole.roleName === "DB Associate") {
    //   this.role = "DBAS"
    // }
    this.role = this.keyValueStore[this.selectedRole.toLowerCase().trim().split(' ').join('')];
    // this.reasons.forEach(element => {
    //   console.log(element)
    //   if(element.viewValue.toLowerCase().trim().split(" ").join("") == this.selectedRole.toLowerCase().trim().split(" ").join("")) {
    //     this.role = element.value
    //   }
    // })
    console.log(this.role);
    const body2 = {
      appCode: 'InTap',
      isLoginUser: 'yes',
      roleCode: this.selectedRole,
    };
    this.contextKeyValue = {};
    this.selectedContext = '';
    this.http.post<any[]>(environment.camsUrl + 'Contexts', body2).subscribe((data) => {
      console.log(data);
      console.log(localStorage.getItem('role'));
      data.forEach((context) => {
        if (context.contextName.toLowerCase().trim() === 'company level') {
          this.contextKey = Object.keys(this.contextKeyValue);
          if (
            this.contextKey.indexOf(context.contextValue) === -1 &&
            context.contextValue.toLowerCase().trim() !== 'all'
          ) {
            this.contextKeyValue[context.contextValue] = context.contextText;
          }
        }
      });
      if (Object.keys(this.contextKeyValue).length == 1) {
        this.selectedContext = Object.keys(this.contextKeyValue)[0];
      }
    });
  }
  onSelectCompHiringType() {
    console.log(this.selectedContext);
  }
}
